export default __webpack_public_path__ + "static/media/surround1.e49345a0.jpg";